import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { PageHeader } from "./Dashboard";
import { FileText, Cpu, User, Server } from "lucide-react";

const ICON = { human: User, agent: Cpu, system: Server };
const COLOR = { human: "text-[var(--jr-info)]", agent: "text-[var(--jr-brand)]", system: "text-[var(--jr-text-2)]" };

export default function AuditLog() {
    const { t, i18n } = useTranslation();
    const [rows, setRows] = useState([]);
    const [filter, setFilter] = useState("");
    const [loading, setLoading] = useState(true);

    const load = () => {
        const params = filter ? `?actor_type=${filter}` : "";
        api.get(`/audit${params}`).then((r) => { setRows(r.data); setLoading(false); });
    };
    useEffect(() => { load(); }, [filter]);

    return (
        <PageHeader
            title={t("audit.title")}
            subtitle={t("audit.subtitle")}
            actions={
                <div className="flex gap-2">
                    {["", "human", "agent", "system"].map((f) => (
                        <button key={f || "all"} onClick={() => setFilter(f)} data-testid={`audit-filter-${f || "all"}`}
                            className={`text-xs font-mono uppercase tracking-[0.16em] px-3 py-2 rounded-full transition-colors ${filter === f ? "bg-[var(--jr-brand)] text-white" : "border border-white/10 text-[var(--jr-text-2)] hover:bg-white/5"}`}>
                            {f || t("common.all")}
                        </button>
                    ))}
                </div>
            }
        >
            {loading ? <div className="text-[var(--jr-text-2)]">{t("common.loading")}</div> :
                rows.length === 0 ? <div className="text-center py-10 text-[var(--jr-text-2)]"><FileText size={28} className="mx-auto"/></div> :
                <div className="rounded-xl border border-white/8 bg-[var(--jr-surface)] overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="bg-[var(--jr-surface-2)] text-[var(--jr-text-3)] text-xs uppercase tracking-[0.16em]">
                            <tr>
                                <th className="text-left px-5 py-3 font-mono font-normal w-32">{t("audit.time")}</th>
                                <th className="text-left px-5 py-3 font-mono font-normal w-28">{t("audit.actor_type")}</th>
                                <th className="text-left px-5 py-3 font-mono font-normal">{t("audit.action")}</th>
                                <th className="text-left px-5 py-3 font-mono font-normal">{t("audit.detail")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r) => {
                                const Icon = ICON[r.actor_type] || Cpu;
                                const col = COLOR[r.actor_type] || "text-[var(--jr-text-2)]";
                                return (
                                    <tr key={r.id} data-testid={`audit-row-${r.id}`} className="border-t border-white/8 hover:bg-white/3 transition-colors">
                                        <td className="px-5 py-3 font-mono text-xs text-[var(--jr-text-3)]">{new Date(r.created_at).toLocaleString(i18n.language === "en" ? "en-GB" : i18n.language === "fr" ? "fr-BE" : "nl-BE", { dateStyle: "short", timeStyle: "short" })}</td>
                                        <td className="px-5 py-3"><span className={`inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-[0.16em] ${col}`}><Icon size={12}/> {r.actor_type}</span></td>
                                        <td className="px-5 py-3 font-mono text-xs text-white">{r.action}</td>
                                        <td className="px-5 py-3 text-[var(--jr-text-2)]">{r.detail}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </PageHeader>
    );
}
